import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * TA-10279: Chat list row placeholder — mirrors `ChatCard.web.tsx`'s expanded
 * row (48x48 avatar circle + title line + preview line, timestamp block at
 * the far right of line 2) and its collapsed rail (just the 48x48 circle).
 */
export const ChatRowSkeleton: React.FC<{
  testID?: string;
  collapsed?: boolean;
}> = ({ testID = 'chat-row-skeleton', collapsed = false }) => {
  if (collapsed) {
    return (
      <Box
        testID={testID}
        height={48}
        alignItems='center'
        justifyContent='center'
        paddingVertical='s'>
        <Skeleton variant='circle' width={48} height={48} />
      </Box>
    );
  }

  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingHorizontal='m'
      style={{ paddingVertical: 10 }}>
      <Skeleton
        variant='circle'
        width={48}
        height={48}
        style={{ marginRight: theme.spacing.xs }}
      />
      <Box flex={1} style={{ gap: theme.spacing.xxs }}>
        <Skeleton variant='text' width='45%' />
        <Box flexDirection='row' justifyContent='space-between'>
          <Skeleton variant='text' width='70%' height={10} />
          <Skeleton
            variant='text'
            width={32}
            height={10}
            style={{ marginLeft: theme.spacing.xxs }}
          />
        </Box>
      </Box>
    </Box>
  );
};
